import * as axios from 'axios'

export const instance = axios.create({
  crossDomain: true,
  baseURL: process.env.VUE_APP_BASE_URI,
  withCredentials: true,
  contentType: 'application/json',
})
